/**
 * AUTO-GENERATED from schema.json — DO NOT EDIT
 * Source: Steps With Image (steps_with_image)
 * Run `yarn workspace @library/cms-blocks cms:types` to regenerate
 */

import { z } from 'zod'
import { CmsAssetSchema } from '../../types/contentstack-zod'
import { RawCmsCtaSchema } from '../../cta'

export const StepsWithImageFieldsSchema = z
  .object({
    heading: z.string(),
    items: z
      .array(
        z
          .object({
            image: CmsAssetSchema,
            image_alt: z.string().nullish(),
            title: z.string(),
            description: z.string().nullish(),
          })
          .passthrough(),
      )
      .nullish(),
    cta: RawCmsCtaSchema.nullish(),
  })
  .passthrough()
